import { render, staticRenderFns } from "./document-lookup.vue?vue&type=template&id=62eb08fe&scoped=true"
import script from "./document-lookup.vue?vue&type=script&lang=js"
export * from "./document-lookup.vue?vue&type=script&lang=js"
import style0 from "./document-lookup.vue?vue&type=style&index=0&id=62eb08fe&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62eb08fe",
  null
  
)

export default component.exports